import React from 'react';
import { useParams } from 'react-router-dom';
import ContractCreate from './ContractCreate';

const ContractView = () => {
  const { id } = useParams();
  // ContractCreate already handles view mode when viewing via this route
  // We'll modify ContractCreate to detect view mode
  return <ContractCreate isView={true} />;
};

export default ContractView;

